import axios from 'axios';
import { Feeder } from 'views/self-service/features/feeders/types/feeders.type';

// GET FEEDERS
// /ewosapi/v1/shrimps/feeder/{globalCompanyId}
export const getFeeders = async (globalCompanyId: string): Promise<Feeder[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/feeder/${globalCompanyId}`);
  return res.data;
};
